<template>
  <div>
    <v-card-text class="my-5 d-flex justify-space-between align-center pa-4">
      <p class="text-h6">Ответственный: {{ responsible_user }}</p>
    </v-card-text>
    <v-card class="my-5">
      <v-card-text>
        <v-card-actions class="px-0">
          <div class="views-history text-body-1 text-sm-h5 black--text">
            Визиты
          </div>
          <v-spacer></v-spacer>
          <v-card elevation="0" class="d-flex align-center">
            <v-card-text
              class="toolbar-content text-caption text-sm-subtitle-1 text-no-wrap py-1 px-2"
            >
              {{ visits.length }} сессий
            </v-card-text>
          </v-card>
          <v-spacer></v-spacer>
          <v-card elevation="0" class="d-flex align-center">
            <v-card-text
              class="toolbar-content text-caption text-sm-subtitle-1 text-no-wrap py-1 px-2"
            >
              {{ visits.length }} визитов
            </v-card-text>
          </v-card>
          <v-spacer></v-spacer>
          <v-btn
            class="white--text"
            style="background-color: #d86568; height: 50px; border-radius: 50px"
            @click="showSessionDialog"
            v-if="cooldown"
          >
            {{ hasHoursPassed(timeout) ? "Начать просмотр" : remainingTime }}
          </v-btn>
        </v-card-actions>
        <object-grid
          :content_type="content_type"
          :value="visits"
          :hide-toolbar="true"
          :show-actions="showActions"
          :field-defs="[
            { text: 'Сессия', value: 'product_name' },
            { text: 'Дата', value: 'prescribed_at' },
          ]"
          @doEditItem="showSessionDialog"
        />
      </v-card-text>
    </v-card>
    <error-message-wrapper ref="error_wrapper" />
  </div>
</template>
<script>
import ObjectGrid from "@/components/ObjectGrid.vue";
import { mapActions, mapGetters } from "vuex";

import SessionForm from "@/components/SessionForm.vue";
import ErrorMessageWrapper from "@/components/ErrorMessageWrapper.vue";
import ApiService from "@/api/ApiService";

export default {
  name: "PatientSessionView",
  components: { ObjectGrid, ErrorMessageWrapper },
  data() {
    return {
      content_type: "products",
      showActions: { edit: false },
      checkSessionInterval: undefined,
      openedSessionUuid: undefined,
      visits: [],
    };
  },
  computed: {
    ...mapGetters(["user"]),
    ...mapGetters(["configProperty"]),
    ...mapGetters("users", ["users"]),
    cooldown() {
      return this.configProperty("patientSessionTimeout");
    },
    timeout() {
      const t = this.user?.Patient?.timeout;
      return t === undefined || t === null ? null : new Date(t);
    },
    responsible_user() {
      const u = this.users.find(
        (user) => user.id === this.user?.Patient?.user_id
      );
      return u ? u.first_name + " " + u.last_name : "";
    },
    remainingTime() {
      if (!this.timeout) return null;
      const requiredTimeInMs = this.cooldown * 60 * 60 * 1000;
      const remainingTimeInMs = requiredTimeInMs - (Date.now() - this.timeout);
      if (remainingTimeInMs <= 0) return null;
      const h = Math.floor(remainingTimeInMs / (1000 * 60 * 60));
      const m = Math.floor(
        (remainingTimeInMs % (1000 * 60 * 60)) / (1000 * 60)
      );
      return `${h} ч ${m} мин`;
    },
  },
  methods: {
    ...mapActions("users", ["request_users"]),
    ...mapActions("modals", ["showModalForm", "closeModalForm"]),
    ...mapActions(["doRequestConfigProperty"]),
    ...mapActions(["doGetUser"]),

    async loadVisits() {
      try {
        const res = await ApiService.get("api/patients/me/visits");
        const active = res?.data?.active || [];
        this.visits = active.map((v) => ({
          ...v,
          viewProgress: v.view_progress,
        }));
      } catch (e) {
        console.error("loadVisits:", e);
      }
    },

    hasHoursPassed(timeoutStart) {
      if (!timeoutStart) return true;
      return Date.now() - timeoutStart >= this.cooldown * 60 * 60 * 1000;
    },

    showSessionDialog() {
      if (this.visits.length === 0) return;
      if (!this.hasHoursPassed(this.timeout)) {
        return this.$refs.error_wrapper.showErrorMessage(
          "Ошибка",
          "Для просмотра новой сессии необходимо подождать " +
            this.remainingTime
        );
      }

      const item = this.visits[0];
      this.openedSessionUuid = item.public_uuid;

      this.showModalForm({
        title: item.product_name,
        component: SessionForm,
        width: this.$vuetify.breakpoint.smAndUp ? "50%" : "80%",
        item,
        patient_id: this.user?.Patient?.id,
      });
    },

    async checkSession() {
      await this.loadVisits();
      const stillThere = this.visits.some(
        (v) => v.public_uuid === this.openedSessionUuid
      );
      if (this.openedSessionUuid && !stillThere) {
        this.closeModalForm();
        this.doGetUser();
      }
    },
  },
  beforeMount() {
    this.request_users();
    this.doRequestConfigProperty("patientSessionTimeout");
    this.loadVisits();
    this.checkSessionInterval = setInterval(() => this.checkSession(), 10000);
  },
  beforeDestroy() {
    clearInterval(this.checkSessionInterval);
  },
};
</script>
<style scoped lang="scss">
.toolbar-content {
  background-color: #f0f8f6;
  color: #d86568 !important;
}
</style>
